"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Input_1 = __importStar(require("../../UI/Input/Input"));
const Theme_1 = require("../../../Theme");
const style = __importStar(require("./styled"));
const useTranslate_1 = require("../../../Hooks/useTranslate");
const PartInput = ({ setPartInputs, defaultPartNo, defaultAmount, index, onPaste, width, widthAmount, disabled }) => {
    const { t } = (0, useTranslate_1.useTranslate)();
    const setCurrentPartNo = (value) => {
        setPartInputs(prev => {
            const copy = [...prev];
            copy[index].partNo = value;
            return copy;
        });
    };
    const setCurrentAmount = (value) => {
        setPartInputs(prev => {
            const copy = [...prev];
            copy[index].amount = value;
            return copy;
        });
    };
    return (react_1.default.createElement(style.InputContainer, null,
        react_1.default.createElement(Input_1.default, { placeholder: t('/haldex/quick_order/part_no'), value: defaultPartNo, setValue: setCurrentPartNo, maxWidth: width || Theme_1.theme.constants.quickOrder.inputWidthMedium, onPaste: e => onPaste(e, index), disabled: disabled }),
        react_1.default.createElement(Input_1.default, { value: defaultAmount, setValue: setCurrentAmount, maxWidth: widthAmount || Theme_1.theme.constants.quickOrder.inputWidthSmall, centerInput: true, type: Input_1.InputTypes.NUMBER, min: 1, integer: true, disabled: disabled })));
};
exports.default = PartInput;
